import Vue from 'vue'

export default {

    SET_CONFIG (state, config) {
        state.config = config
    },

    SET_LIST (state, data) {
        Vue.set(state.lists, data.listName, data.items)
    },

    SET_CLUSTER (state, cluster) {
        state.cluster = cluster
    },

    SET_UUID (state, uuid) {
        state.uuid = uuid
    },

    SET_VALIDATION (state, validation) {
        state.validation = validation
    }
    
}
